import styled from "styled-components";

import { GameHistoryRow } from "@lindar-joy/goosicorn-quickies-library";

export interface CrashPayload {
  engineData: CrashEngineData;
  gameAction: string; 
}

export interface CrashEngineData {
  '@type': 'CrashEngineData';
  crashResult: CrashResult;
}

export interface CrashResult {
  flyingDistance: number;   
  engineRoundId: string;    
  engineRoundTime: number;
}

export type CrashActionType = 'crash:bet' | 'crash:collect' | 'crash:cancel';

export interface ParsedCrashAction {
  type: CrashActionType;
  engineRoundId: string;
  betId?: string;          
  bet?: number;             
}



export const GameHistoryRenderer = (gameRound: CrashPayload) => {
    const multiplier = gameRound.engineData.crashResult.flyingDistance;
    const label = multiplier === 100 ? "Crashed" : (multiplier/100).toFixed(2)+"x";

    return <GameHistoryRow><div>Multiplier</div><div>{ label }</div></GameHistoryRow>;
}
